export default __webpack_public_path__ + "static/media/card-front-square.5750fef7.jpg";